import { render, staticRenderFns } from "./HelpToBuy.vue?vue&type=template&id=0df198f8"
import script from "./HelpToBuy.vue?vue&type=script&lang=js"
export * from "./HelpToBuy.vue?vue&type=script&lang=js"
import style0 from "./HelpToBuy.vue?vue&type=style&index=0&id=0df198f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports